"use client";

import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface VerticalMarqueeProps {
  children: ReactNode;
  reverse?: boolean;
  pauseOnHover?: boolean;
  className?: string;
  /** Duration in seconds for one full loop. */
  speed?: number;
}

export function VerticalMarquee({
  children,
  reverse = false,
  pauseOnHover = false,
  className,
  speed = 40,
}: VerticalMarqueeProps) {
  const animationDirection = reverse ? "reverse" : "normal";
  return (
    <div
      className={cn(
        "group relative flex h-full w-full flex-col overflow-hidden [--gap:1rem]",
        className,
      )}
      style={{ ["--marquee-duration" as string]: `${speed}s` }}
    >
      <div
        className={cn(
          "flex shrink-0 flex-col gap-[var(--gap)] animate-marquee-y",
          pauseOnHover && "group-hover:[animation-play-state:paused]",
        )}
        style={{ animationDirection }}
      >
        {children}
      </div>
      <div
        aria-hidden
        className={cn(
          "mt-[var(--gap)] flex shrink-0 flex-col gap-[var(--gap)] animate-marquee-y",
          pauseOnHover && "group-hover:[animation-play-state:paused]",
        )}
        style={{ animationDirection }}
      >
        {children}
      </div>
    </div>
  );
}
